export default ` 
    <div id="#= data.containerId #" class="#= data.containerClasses || "" # #=data.bsc||""#">
        <div id="#= data.id #" class="#= data.classes || "" #">
        </div>
    </div>
`;
